<section id="main-container">
    <app-modal-message
            #modalMessage
            (ok)="checkResponseModal(true)"
            (close)="checkResponseModal(false)"
            title="Atenção!"
            labelOk="Sim"
            labelClose="Não">
    </app-modal-message>
    <div class="col-md-4 col-lg-3 col-xl-3" id="fichas-etapa-container">
        <app-ficha-cadastro-lateral [fichaCadastro]="fichaCadastro"></app-ficha-cadastro-lateral>
    </div>
    <div id="main" class="col-xs-12 col-sm-12 col-md-8 col-lg-9 col-xl-9">
        <app-breadcrumb currentPage="Cadastrar Nova Ficha" routerCurrentPage="/nova"></app-breadcrumb>
        <div id="new-record" class="row">
            <div class="col col-xs-12">
                <form action="" class="forms">
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane" [ngClass]="{'active': fichaCadastro.passo === fichaCadastro.PASSO_VENDEDOR}" id="formA">
                          <app-ficha-cadastro-lojista-vendedor [fichaCadastro]="fichaCadastro"></app-ficha-cadastro-lojista-vendedor>
                        </div>
                        <div role="tabpanel" class="tab-pane" [ngClass]="{'active': fichaCadastro.passo === fichaCadastro.PASSO_CLIENTE}" id="formB">
                            <app-ficha-cadastro-cliente [fichaCadastro]="fichaCadastro"></app-ficha-cadastro-cliente>
                        </div>
                        <div role="tabpanel" class="tab-pane" [ngClass]="{'active': fichaCadastro.passo === fichaCadastro.PASSO_VEICULO || fichaCadastro.passo === fichaCadastro.PASSO_VEICULO_PROPRIO}" id="formC">
                          <app-ficha-cadastro-veiculo-proprio
                            *ngIf="fichaCadastro.passo === fichaCadastro.PASSO_VEICULO_PROPRIO"
                            [fichaCadastro]="fichaCadastro">
                          </app-ficha-cadastro-veiculo-proprio>
                          <app-ficha-cadastro-veiculo
                            #cadastroVeiculo
                            [hidden]="fichaCadastro.passo !== fichaCadastro.PASSO_VEICULO"
                            [fichaCadastro]="fichaCadastro">
                          </app-ficha-cadastro-veiculo>
                        </div>
                        <div role="tabpanel" class="tab-pane" [ngClass]="{'active': fichaCadastro.passo === fichaCadastro.PASSO_CONSULTANDO_DADOS}"
                            id="formD">
                            <app-ficha-cadastro-consultando-dados [fichaCadastro]="fichaCadastro"></app-ficha-cadastro-consultando-dados>
                        </div>
                        <div role="tabpanel" class="tab-pane" [ngClass]="{'active': fichaCadastro.passo === fichaCadastro.PASSO_RESULTADO_PARCIAL}"
                            id="formE">
                            <app-ficha-cadastro-resultado-parcial
                              #resultadoParcial
                              [isEtapa]="fichaCadastro.passo === fichaCadastro.PASSO_RESULTADO_PARCIAL"
                              [fichaCadastro]="fichaCadastro">
                            </app-ficha-cadastro-resultado-parcial>
                        </div>
                        <div role="tabpanel" class="tab-pane" [ngClass]="{'active': fichaCadastro.passo === fichaCadastro.PASSO_DETALHE_CLIENTE || fichaCadastro.passo === fichaCadastro.PASSO_CAMINHAO_CLIENTE}"
                            id="formF">
                            <app-ficha-cadastro-detalhe-cliente
                              [hidden]="fichaCadastro.passo !== fichaCadastro.PASSO_DETALHE_CLIENTE"
                              [fichaCadastro]="fichaCadastro">
                            </app-ficha-cadastro-detalhe-cliente>
                            <app-ficha-cadastro-detalhe-cliente-caminhao-proprio
                              *ngIf="fichaCadastro.passo === fichaCadastro.PASSO_CAMINHAO_CLIENTE && fichaCadastro.isPesados"
                              [fichaCadastro]="fichaCadastro">
                            </app-ficha-cadastro-detalhe-cliente-caminhao-proprio>
                        </div>
                        <div *ngIf="fichaCadastro.avalistas.length >= 1 || amountGuarantor >= 1" role="tabpanel" class="tab-pane" [ngClass]="{'active': fichaCadastro.passo === fichaCadastro.PASSO_DETALHE_AVALISTA}"
                            id="formFA">
                            <app-ficha-cadastro-detalhe-avalista [fichaCadastro]="fichaCadastro" index="0"></app-ficha-cadastro-detalhe-avalista>
                        </div>
                        <div *ngIf="fichaCadastro.avalistas.length >= 2 || amountGuarantor >= 2" role="tabpanel" class="tab-pane" [ngClass]="{'active': fichaCadastro.passo === fichaCadastro.PASSO_DETALHE_AVALISTA_2}"
                            id="formFA2">
                            <app-ficha-cadastro-detalhe-avalista [fichaCadastro]="fichaCadastro" index="1"></app-ficha-cadastro-detalhe-avalista>
                        </div>
                        <div *ngIf="fichaCadastro.avalistas.length >= 3 || amountGuarantor >= 3" role="tabpanel" class="tab-pane" [ngClass]="{'active': fichaCadastro.passo === fichaCadastro.PASSO_DETALHE_AVALISTA_3}"
                            id="formFA3">
                            <app-ficha-cadastro-detalhe-avalista [fichaCadastro]="fichaCadastro" index="2"></app-ficha-cadastro-detalhe-avalista>
                        </div>
                        <div role="tabpanel" class="tab-pane" [ngClass]="{'active': fichaCadastro.passo === fichaCadastro.PASSO_ENDERECO_CLIENTE}"
                            id="formG">
                            <app-ficha-cadastro-endereco-cliente [fichaCadastro]="fichaCadastro"></app-ficha-cadastro-endereco-cliente>
                        </div>
                        <div *ngIf="fichaCadastro.avalistas.length >= 1 || amountGuarantor >= 1" role="tabpanel" class="tab-pane" [ngClass]="{'active': fichaCadastro.passo === fichaCadastro.PASSO_ENDERECO_AVALISTA}"
                            id="formGA">
                            <app-ficha-cadastro-endereco-avalista [fichaCadastro]="fichaCadastro" index="0"></app-ficha-cadastro-endereco-avalista>
                        </div>
                        <div *ngIf="fichaCadastro.avalistas.length >= 2 || amountGuarantor >= 2" role="tabpanel" class="tab-pane" [ngClass]="{'active': fichaCadastro.passo === fichaCadastro.PASSO_ENDERECO_AVALISTA_2}"
                            id="formGA">
                            <app-ficha-cadastro-endereco-avalista [fichaCadastro]="fichaCadastro" index="1"></app-ficha-cadastro-endereco-avalista>
                        </div>
                        <div *ngIf="fichaCadastro.avalistas.length >= 3 || amountGuarantor >= 3" role="tabpanel" class="tab-pane" [ngClass]="{'active': fichaCadastro.passo === fichaCadastro.PASSO_ENDERECO_AVALISTA_3}"
                            id="formGA">
                            <app-ficha-cadastro-endereco-avalista [fichaCadastro]="fichaCadastro" index="2"></app-ficha-cadastro-endereco-avalista>
                        </div>
                        <div *ngIf="fichaCadastro.passo === fichaCadastro.PASSO_OBSERVACAO" role="tabpanel" class="tab-pane" [ngClass]="{'active': fichaCadastro.passo === fichaCadastro.PASSO_OBSERVACAO}" id="formH">
                            <app-ficha-cadastro-observacao [fichaCadastro]="fichaCadastro"></app-ficha-cadastro-observacao>
                        </div>
                        <div role="tabpanel" class="tab-pane" [ngClass]="{'active': fichaCadastro.passo === fichaCadastro.PASSO_ANALISE}" id="formI">
                            <app-ficha-cadastro-analise [fichaCadastro]="fichaCadastro"></app-ficha-cadastro-analise>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    </div>


</section>
